import { Container } from "pixi.js";
import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponent";
import { GunShoot } from "./GunShoot";

export class GunShootComponent extends AbstractDisplayComponent {
    private container: GunShoot;

    public override init() {
        let config = {
            labelName: "gunShootComponent",
            anchorX: 0.5,
            anchorY: 0.5,
            landscape: {
                posX: 1079,
                posY: 779,
                scale: 1,
            },
            portrait: {
                posX: 878,
                posY: 776,
                scale: 0.65,
            }
        };

        super.init();
        this.container = new GunShoot(config);
    }



    public getInstance(): Container {

        return this.container;

    }



    public override destroy(): void {

        this.container.destroy({ children: true });

    }



    public animateCharacter(variant?: string): void {
        variant;
        //this.container.animateCharacter(variant);

    }

    public showHand(): void {
        this.container.showHand();
    }

}

